/* ============================================
   Bigg Jeff's Theme - global.js
   Lightweight, vanilla JS. No framework needed.
   ============================================ */

(function () {
  'use strict';

  /* -------- Mobile menu toggle -------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function () {
      siteNav.classList.toggle('is-open');
      var expanded = siteNav.classList.contains('is-open');
      menuToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* -------- Toast helper -------- */
  function showToast(msg) {
    var toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  /* -------- Quick Add (Add To Cart from product cards) -------- */
  // Uses Shopify's /cart/add.js endpoint
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.textContent = 'Added ✓';
        showToast('Added to cart');
        updateCartCount();
        setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1400);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        showToast('Could not add to cart');
      });
  });

  /* -------- Update cart counter -------- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counter = document.querySelector('[data-cart-count]');
        if (counter) {
          counter.textContent = cart.item_count;
          counter.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        }
      });
  }

  /* -------- Product page: thumbnail switcher -------- */
  var thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var src = t.getAttribute('data-src');
      var main = document.querySelector('[data-main-image]');
      if (main && src) main.src = src;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* -------- Product page: variant swatches -------- */
  var swatches = document.querySelectorAll('[data-variant-swatch]');
  swatches.forEach(function (s) {
    s.addEventListener('click', function () {
      var vid = s.getAttribute('data-variant-id');
      var price = s.getAttribute('data-variant-price');
      swatches.forEach(function (x) { x.classList.remove('is-active'); });
      s.classList.add('is-active');
      var input = document.querySelector('[data-variant-input]');
      if (input && vid) input.value = vid;
      var pdpPrice = document.querySelector('[data-pdp-price]');
      if (pdpPrice && price) pdpPrice.textContent = price;
    });
  });

  /* -------- Product page: quantity steppers -------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = Math.max(1, v + step);
    input.value = v;
  });

  /* -------- Initial -------- */
  updateCartCount();
})();
